import { TwoColFormRow } from "../../../Molecules/Form/TwoColFormRow";
import { DisconnectButton } from "../../DisconnectButton";

export function DangerZone() {
  return (
    <TwoColFormRow
      heading={ `Danger Zone` }
      headingClassName={ `text-red-600` }
    >
      <DisconnectButton />
    </TwoColFormRow>
  );
}
